<template lang="pug">
  #relatorios-ouvidoria
    el-row(:gutter="20")
      el-col(:span="24")
        .main-container
          card-dashboard.custom-card(
            title="Total de conversas" :content="somaTotalDeConversas"
            icon="far fa-comments" color="#00537e"
          )
          card-dashboard.custom-card(
            title="Encerradas" :content="finalizadas"
            icon="far fa-calendar-check" color="blue"
          )
          card-dashboard.custom-card(
            title="Respondidas" :content="respondidas"
            icon="far fa-comment-check" color="green"
          )
          card-dashboard.custom-card(
            title="Aguardando resposta" :content="aguardandoResposta"
            icon="far fa-alarm-exclamation" color="yellow"
          )
    el-card(shadow="hover")
      p.bolder Gráficos
      el-tabs(v-model="activeTab")
        el-tab-pane(
          v-for="item in tabConversas"
          :key="item.name"
          :label="item.label"
          :name="item.name"
        )
          component(:is="item.component" v-if="activeTab === item.name")
</template>

<script>
import { CardDashboard } from 'sicarf-components'
import { mapActions } from 'vuex'

import AppConversasStatus from './components/conversas/AppConversasStatus'
import AppConversasPeriodo from './components/conversas/AppConversasPeriodo'
import AppConversasAssunto from './components/conversas/AppConversasAssunto'
import AppConversasResponsavel from './components/conversas/AppConversasResponsavel'

export default {
  name: 'RelatoriosOuvidoria',
  components: {
    CardDashboard,
    AppConversasStatus,
    AppConversasPeriodo,
    AppConversasAssunto,
    AppConversasResponsavel
  },
  data () {
    return {
      conversas: {},
      somaTotalDeConversas: 0,
      finalizadas: 0,
      respondidas: 0,
      aguardandoResposta: 0,
      activeTab: 'conversasStatus',
      tabConversas: {
        conversasStatus: {
          label: 'Conversas por Status',
          name: 'conversasStatus',
          component: AppConversasStatus
        },
        conversasPeriodo: {
          label: 'Conversas por Período',
          name: 'conversasPeriodo',
          component: AppConversasPeriodo
        },
        conversasAssunto: {
          label: 'Conversas por Assunto',
          name: 'conversasAssunto',
          component: AppConversasAssunto
        },
        conversasResponsavel: {
          label: 'Conversas por Responsável',
          name: 'conversasResponsavel',
          component: AppConversasResponsavel
        }
      }
    }
  },

  async created () {
    await this.loadData()
  },
  props: {
    RelatorioService: this.RelatorioService,
    pageSize: {
      type: Number,
      default: 10
    },
    loading: {
      Type: Boolean,
      default: false
    }
  },

  methods: {
    ...mapActions({
      getAllConversas: 'carddashboardRelatorios/getAllConversas'
    }),
    async loadData () {
      this.conversas = await this.getAllConversas()
      this.finalizadas = this.conversas.finalizadas
      this.respondidas = this.conversas.respondidas
      this.aguardandoResposta = this.conversas.aguardandoResposta
      this.somaTotalDeConversas = this.aguardandoResposta + this.respondidas + this.finalizadas
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style lang="scss" scoped>

  .custom-card {
    margin-right: 40px;
    max-width: 210px;
    font-size: 18px;
  }

  .main-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  .bolder {
    font-size: 20px;
    font-weight: bolder;
  }

  /deep/ .el-tabs__item {
    font-size: 16px;
    color: #424242;

    &.is-active {
      font-weight: bolder;
    }
  }
  /* CSS Abaixo para o el-tabs ficar no centro sendo responsivo com @media */
  /* @media only screen and (width: 1920px) {
   /deep/ .el-tabs__item {
      padding: 0 8rem;
   }
  } */

  /deep/ .el-tabs__nav-scroll {
    display: flex;
    place-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/screens/relatorios_ouvidoria/RelatoriosOuvidoria.vue